<template>
  <div class="order">
    <div class="order_header_container">
      <div v-if="order.trackingNumber" class="status_when_tracking_exist">
        <div class="status">{{ orderStatus[order.status] }}</div>
        <div class="strech"></div>
        <div class="order_number">Order# {{ order.orderNumber }}</div>
      </div>
      <div class="order_header">
        <div class="status" :class="{'link_a_like' : order.trackingNumber}" @click="openTrackingNumber(order)">
          {{ !order.trackingNumber ? orderStatus[order.status] : 'Track Order' }}
        </div>
        <div
          v-if="orderStatus[order.status] !== 'Refunded' && orderStatus[order.status] !== 'Rejected' && getDeliveryEstimation(order)"
        >
          <div>Estimated Deliver at: {{ getDeliveryEstimation(order) }}</div>
        </div>
        <div v-if="!order.trackingNumber">
          Order# {{ order.orderNumber }}
        </div>
        <div class="strech" />
        <div>
          <div v-if="showOrderDetailsButton">
            <a @click="onOrderClick(order)">Order details</a>
          </div>
        </div>
      </div>
    </div>
    <div class="details">
      <div class="order_details">
        <img class="order_item_image pointer" v-lazy-load :data-src="getItem(order.itemId).image" @click="showItem(order.itemId)" alt="order item">
        <div>
          <div><a @click="showItem(order.itemId)">{{ getItem(order.itemId).name }}</a></div>
          <div>Sold by: <a @click="showUser(getUser(order.sellerId))">{{ getUser(order.sellerId).name }}</a></div>
          <div v-if="order.status !== 2 && order.status < 7">
            {{ (getReturnsMessage(order)) }}
          </div>
          <div class="item_price">
            <div v-if="!getOrderCredit && !order.supersetDiscount" class="red item_price">
              ${{ (order.itemPrice - (order.supersetDiscount || 0)) | numFormat('0.00') }}
            </div>
            <div v-else>
              <span class="old_price">${{ parseInt(order.itemPrice) }}</span>
              <span class="red">${{ order.itemPrice - ((order.supersetDiscount || 0) > 0 ? order.supersetDiscount : getOrderCredit.offerSum) }}</span>
            </div>
          </div>
        </div>
        <div class="strech" />
        <div>
          <div class="gotit_button contact_seller" @click="contactSeller()">
            Contact seller
          </div>
          <div
            v-if="orderStatus[order.status] === 'Shipped' || orderStatusReturnInProgress[order.status]"
            class="gotit_button return_item"
            @click="returnRequestDialog()"
          >
            <span v-if="order.status === 7">Waiting for request approval</span>
            <span v-else-if="order.status === 8">Update return tracking number</span>
            <span v-else-if="orderStatusReturnInProgress[order.status]">View return</span>
            <span v-else>Return this item</span>
          </div>
          <div v-if="userCanLeaveFeedback[order.status]" class="gotit_button leave_feedback" @click="leaveFeedback()">
            Leave feedback
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import utils from '~/mixins/utils'

export default {
  name: 'OrderComponent',
  mixins: [utils],
  props: {
    order: {},
    // eslint-disable-next-line vue/require-prop-type-constructor
    showOrderDetailsButton: false
  },
  data () {
    return {
      orders: [],
      orderStatus: ['Paid', 'Accepted', 'Rejected', 'Shipped', 'Delivery Confirmed', 'Order failed', 'Pending', 'Request Return', 'Return Accepted', 'Returned Rejected', 'Item Returned', 'Refunded'],
      userCanLeaveFeedback: [false, false, false, true, true, false, false, true, true, true, true, true],
      monthNames: [
        'January', 'February', 'March',
        'April', 'May', 'June', 'July',
        'August', 'September', 'October',
        'November', 'December'
      ],
      orderStatusReturnInProgress: [false, false, false, false, false, false, false, true, true, true, true, true],
      isUPS: /^1Z[A-H,J-N,P,R-Z,0-9]{16}$/,
      isFedEx: /^\d{12}$|^\d{15}$/,
      isUSPS: /^\d{20,22}$|^[A-Z]{2}[0-9,A-Z]{9}US$/,
      isDHL: /^[0-9]{10,11}$/,
      isCAPost: /^\d{16}$|^[A-Z]{2}\d{9}[A-Z]{2}$/
    }
  },
  computed: {
    getOrderCredit () {
      return this.order.creditId ? this.getOffer(this.order.creditId) : null
    }
  },
  mounted () {
  },
  methods: {
    getReturnsMessage (order) {
      const st = this.getShippingType(order.shippingTypeId)
      if (st) {
        const day = 1000 * 60 * 60 * 24
        // const now = Date.now()
        const fromDate = new Date(order.createdAt + day * st.businessDaysFrom)
        const toDate = new Date(order.createdAt + day * st.businessDaysTo)
        return 'Expected delivery date: ' + fromDate.toISOString().split('T')[0] + ' -- ' + toDate.toISOString().split('T')[0]
      } else {
        return ''
      }
    },
    showUser (user) {
      if (user.store) {
        this.$router.push({
          path: '/stores/' + this.encrypt(user.id)
        })
      } else {
        this.$router.push({
          path: '/users/' + this.encrypt(user.id)
        })
      }
    },
    showItem (itemId) {
      this.addItemDetailsToEventsLayer('select_item', itemId)
      this.$router.push({
        path: '/items/' + this.encrypt(itemId)
      })
    },
    onOrderClick (order) {
      this.$router.push({
        path: '/orders/' + this.encrypt(order.id)
      })
    },
    openTrackingNumber (order) {
      let trackNumHref = null
      if (order.trackingNumber) {
        const trkngNmbr = order.trackingNumber
        if (this.isUPS.test(trkngNmbr)) {
          trackNumHref = `https://wwwapps.ups.com/WebTracking/processInputRequest?AgreeToTermsAndConditions=yes&loc=en_US&tracknum=${trkngNmbr}&Requester=trkinppg`
        } else if (this.isFedEx.test(trkngNmbr)) {
          trackNumHref = `https://www.fedex.com/apps/fedextrack/index.html?tracknumber=${trkngNmbr}`
        } else if (this.isUSPS.test(trkngNmbr)) {
          trackNumHref = `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trkngNmbr}`
        } else if (this.isDHL.test(trkngNmbr)) {
          trackNumHref = `http://www.dhl.com/en/express/tracking.html?AWB=${trkngNmbr}&brand=DHL`
        } else if (this.isCAPost.test(trkngNmbr)) {
          trackNumHref = `https://www.canadapost.ca/trackweb/en#/search?searchFor=${trkngNmbr}`
        } else {
          trackNumHref = `https://www.packagetrackr.com/track/${trkngNmbr}`
        }
        window.location.replace(trackNumHref)
      }
    },
    getFormattedDate (date) {
      date = new Date(date)
      const day = date.getDate()
      const monthIndex = date.getMonth()
      const year = date.getFullYear()
      return this.monthNames[monthIndex] + ' ' + day + ', ' + year
    },
    getDeliveryEstimation (order) {
      const shippingType = this.getShippingType(order.shippingTypeId)
      const draftOrder = this.getDraftOrder(order.draftOrderId)
      if (draftOrder && draftOrder.shopifySelectedShippingRate && draftOrder.shopifyShippingRates) {
        JSON.parse(draftOrder.shopifyShippingRates).shipping_rates.forEach((shippingRate) => {
          if (shippingRate.id === draftOrder.shopifySelectedShippingRate) {
            shippingType.type = shippingRate.title
            shippingType.cost = shippingRate.price
            if (shippingRate.delivery_range) {
              if (shippingRate.delivery_range.length === 2) {
                const from = shippingRate.delivery_range[0]
                const to = shippingRate.delivery_range[1]
                shippingType.businessDaysFrom = from
                shippingType.businessDaysTo = to
              }
            }
          }
        })
        shippingType.type = shippingType.type.replace('\\n', '\n')
        if (shippingType.businessDaysFrom) {
          return shippingType.businessDaysFrom.split('T')[0] + ' - ' + shippingType.businessDaysTo.split('T')[0]
        } else {
          const day = 1000 * 60 * 60 * 24
          const from = new Date(order.createdAt + day * 3)
          const to = new Date(order.createdAt + day * 10)
          return from.toISOString().split('T')[0] + ' - ' + to.toISOString().split('T')[0]
        }
      }
    },
    getItem (itemId) {
      return this.$store.state.api.buckets.items[itemId]
    },
    getDraftOrder (draftOrderId) {
      return this.$store.state.api.buckets.draftOrders[draftOrderId]
    },
    getShippingType (shippingTypeId) {
      return this.$store.state.api.buckets.shippingTypes[shippingTypeId]
    },
    getUser (userId) {
      return this.$store.state.api.buckets.users[userId]
    },
    returnRequestDialog () {
      this.$root.$emit('show_return_request_dialog', { order: this.order })
    },
    leaveFeedback () {
      this.$root.$emit('show_leave_feedback_dialog', { order: this.order })
    },
    contactSeller () {
      this.$root.$emit('show_chat', {
        type: 'ORDER',
        order: this.order
      })
    }
  }
}
</script>

<style scoped>
.order {
  width: 920px;
  margin: auto;
  border-radius: 4px;
  border: 1px #ddd solid;
  margin-bottom: 1em;
}

.mobile_design .order {
  width: 100%;
}

.order_header_container {
  background-color: #f6f6f6;
}

.status_when_tracking_exist {
  padding-left: 1em;
  padding-top: 1em;
  display: flex;
  flex-direction: row;
}

.order_header {
  display: flex;
  padding: 1em;
  border-bottom: 1px #ddd solid;
}

.ship_to {
  flex-grow: 1;
}

a {
  color: #0066c0;
  cursor: pointer;
}

.ship_to, .total {
  margin-left: 5em;
}

.status {
  font-weight: 700;
  margin-right: 1em;
}

.details {
  padding: 1em;
  background-color: white;
}

.order_item_image {
  width: 90px !important;
  height: 90px !important;
  margin-right: 1em;
}

.order_details {
  display: flex;
  margin-top: 1em;
}

.item_price {
  color: #B12704;
}

.return_item, .leave_feedback, .contact_seller {
  margin-bottom: 1em;
}

.mobile_design .gotit_button {
  font-size: 11px;
  white-space: nowrap;
  line-height: 25px;
}

.track_order {
  margin-left: 0.2em;
}

.link_a_like {
  font-weight: unset;
  color: #0066c0;
  cursor: pointer;
}

.order_number {
  font-weight: 0;
  padding-right: 1em;
}
</style>
